
import { mapGetters } from 'vuex'
import countryData from '~/data/countryData.json'
export default {
  name: 'TeflTableCountries',
  props: {
    type: {
      type: String,
      default: 'all',
    },
    country: {
      type: String,
      default: '',
    },
    job_guides: {
      type: String,
      default: 'false',
    },
    country_guides: {
      type: String,
      default: 'false',
    },
    continent: {
      type: String,
      default: '',
    },
    sub_continent: {
      type: String,
      default: '',
    },
    salary: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ready: false,
      activeRegion: 'asia',
      subcontinents: {
        asia: ['Central Asia', 'East Asia',  'Southeast Asia', 'South Asia', 'Oceania'],
        europe: ['Central Europe', 'Northern Europe', 'Eastern Europe', 'Western Europe', 'Southern Europe'],
        africa: ['Northern Africa', 'Eastern Africa', 'Southern Africa', 'Western Africa'],
        americas: ['Central America', 'North America', 'South America', 'Caribbean'],
        middleeast: ['Middle East']
      },
      activeSubRegion: '',
      guides: countryData,
    }
  },
  head() {
    if(this.ready){
    return {
            script: [{ type: 'application/ld+json', json: this.structuredData }]
        }
      }
    },
  computed: {
    ...mapGetters({
      page: 'pages/getPage'
    }),
    single_country() {
      let country = null;
      if(this.$props.type !== '' && this.$props.country !== ''){
        country = this.guides[this.$props.type].filter(
          (el) => el.name === this.$props.country
        )[0]
        if(!country){
          return null;
        }
      }
      return country
    },
    region() {
      if(this.$props.type === 'all') {
        return this.guides[this.activeRegion]
      }
      else if(this.$props.type === 'no_experience') {
        return this.guides[this.activeRegion].filter((country) => country.experience !== 'Yes')
      }
      else if(this.$props.type === 'no_degree') {
        return this.guides[this.activeRegion].filter((country) => country.degree !== 'Yes')
      }
      else if(this.$props.type === 'non_native') {
        return this.guides[this.activeRegion].filter((country) => country.nonNative === 'Yes')
      }
      else {return []}
    },
    subRegion () {
      if(this.$props.continent) {
        return this.guides[this.$props.continent].filter((country) => country.subRegion === this.activeSubRegion)
      }
      else {
        return ''
      }
    },
    schemaContent() {
      if(this.$props.type === 'no_experience') {
        return {
          name: 'Best Countries for Teaching English Abroad for teachers with no experience (Comparison) | The TEFL Org',
          description: 'Containing information about different countries for teachers with no experience, their monthly rates, requirements, and other details.',
        }
      }
      if(this.$props.type === 'no_degree') {
        return {
          name: 'Best Countries for Teaching English Abroad for teachers with no degree (Comparison) | The TEFL Org',
          description: 'Containing information about different countries for teachers with no degree, their monthly rates, requirements, and other details.',
        }
      }
      if(this.$props.type === 'non_native') {
        return {
          name: 'Best Countries for Teaching English Abroad for non-native teachers (Comparison) | The TEFL Org',
          description: 'Containing information about different countries for non-native teachers, their monthly rates, requirements, and other details.',
        }
      }
      if(this.$props.type === 'continent') {
        return {
          name: `Best countries to teach English in ${this.$props.continent === 'americas'? 'the':''} ${this.$props.continent.charAt(0).toUpperCase() + this.$props.continent.slice(1)} (Comparison) | The TEFL Org`,
          description: 'Containing information about different countries, their monthly rates, requirements, and other details.',
        }
      }
      if(this.$props.type === 'country') {
        return {
          name: `Requirements to teach English in ${this.$props.country} | The TEFL Org`,
          description: `Containing information about ${this.$props.country}, their monthly rates, requirements, and other details.`,
        }
      }
      else{
        return {
          name: 'Best Countries for Teaching English Abroad (Comparison) | The TEFL Org',
          description: 'Containing information about different countries, their monthly rates, requirements, and other details.',
        }
      }
    },
    structuredData() {
      return {
        "@context": "https://schema.org",
        "@type": "Table",
        "about": this.schemaContent.description,
        "url":`https://www.tefl.org/teach-english-abroad/${this.page}`,
        "author":{
          "@type":"Organization",
          "name":"The TEFL Org"
        },
        "headline": this.schemaContent.name, // pae or table - can just use props here?g
      }
    }
  },
  mounted (){
    console.log('TABLES: ',this.$props.type, this.$props.country)
    // this.showRegion('asia')
    if(this.$props.continent) {
      if(this.$props.sub_continent){
        this.showSubRegion(this.$props.sub_continent)
      } else {
        this.showSubRegion(this.subcontinents[this.$props.continent][0])
      }
    }

    this.ready = true
  },
  methods: {
    isActive (regionTab, isSubRegion) {
      if(isSubRegion) {return this.activeSubRegion === regionTab}
      else {
        return this.activeRegion === regionTab
      }
    },
    showRegion(name) {
      this.activeRegion = name
    },
    showSubRegion(name) {
      this.activeSubRegion = name
    },
  }
}
